import React, { useContext } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { Alert, Stack } from '@mui/material'
import CheckCircle from '@mui/icons-material/CheckCircle'
import Cancel from '@mui/icons-material/Cancel'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import { VehicleContext } from '../SingleVehicle'
import { SectionHeader } from './SectionKit'

const AssetsSection = () => {
  const { vehicle } = useContext(VehicleContext)
  const navigate = useNavigate()
  const assets = vehicle?.assets ?? []

  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="Assigned Assets"
        caption="Equipment from the Asset Manager currently assigned to this vehicle"
      />
      {assets.length === 0 ? (
        <Alert severity="info">
          No assets are assigned to this vehicle. Assets are assigned from
          their page in the Asset Manager.
        </Alert>
      ) : (
        <CustomDataGrid
          rows={assets}
          onRowClick={({ row }) => navigate('/asset-manager/' + row.assetID)}
          columns={[
            { field: 'assetID', headerName: 'Asset ID' },
            { field: 'category', headerName: 'Category', flex: 1 },
            { field: 'subCategory', headerName: 'Sub Category', flex: 1 },
            {
              field: 'serviceDue',
              headerName: 'Service',
              headerAlign: 'center',
              align: 'center',
              renderCell: ({ row }) =>
                row.latestMaintenanceLog &&
                moment(row.latestMaintenanceLog?.expiry) <=
                  moment().startOf('day') ? (
                  <Cancel color="error" />
                ) : (
                  <CheckCircle color="success" />
                ),
            },
            {
              field: 'defects',
              headerName: 'Defects',
              align: 'center',
              headerAlign: 'center',
              renderCell: (params) => params.row.defects?.length ?? null,
            },
          ]}
          disableRowSelectionOnClick
          slots={{ footer: () => null, toolbar: () => null }}
        />
      )}
    </Stack>
  )
}

export default AssetsSection
